import React from "react";
import { cva } from "class-variance-authority";
import { LoadingSpinner } from "./LoadingSpinner";

export const buttonVariants = cva(
  "inline-flex items-center justify-center rounded font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-background min-w-[60px]",
  {
    variants: {
      variant: {
        default: "bg-primary text-white hover:bg-primary/90",
        destructive: "bg-danger text-white hover:bg-danger/90",
        outline:
          "border border-border hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "underline-offset-4 hover:underline text-primary",
      },
      size: {
        default: "min-h-10 py-2 px-4",
        sm: "min-h-9 px-3 rounded",
        lg: "min-h-11 px-8 rounded",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

export const MyButton = React.forwardRef(function Button(
  {
    className,
    id,
    variant = "default",
    size,
    children,
    loading,
    disabled,
    ...props
  },
  ref,
) {
  return (
    <button
      id={id}
      disabled={disabled || loading}
      className={buttonVariants({ variant, size, className })}
      ref={ref}
      {...props}
    >
      {loading && (
        <LoadingSpinner
          className={`w-4 h-4 ${variant === "default" && "border-background border-t-transparent"} me-2`}
        />
      )}
      {children}
    </button>
  );
});
MyButton.displayName = "Button";
